var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.198,
    height: 16.198,
    viewBox: "0 0 16.198 16.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "name",
    transform: "translate(-435.9 300.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34291",
    "data-name": "Path 34291",
    d: "M11,5.666A3.111,3.111,0,1,0,14.11,8.777,3.111,3.111,0,0,0,11,5.666ZM11,11a2.222,2.222,0,1,1,2.222-2.222A2.222,2.222,0,0,1,11,11Zm0-8a8,8,0,1,0,8,8A8,8,0,0,0,11,3ZM6.555,15.607v-.164a1.778,1.778,0,0,1,1.778-1.778h5.333a1.778,1.778,0,0,1,1.778,1.778v.164a1.755,1.755,0,0,1-.839,1.515,7.075,7.075,0,0,1-7.209,0A1.755,1.755,0,0,1,6.555,15.607Zm9.777.079v-.243a2.666,2.666,0,0,0-2.666-2.666H8.333a2.666,2.666,0,0,0-2.666,2.666v.243a7.11,7.11,0,1,1,10.665,0Z",
    transform: "translate(433 -303)",
    fill: "#39be9d",
    stroke: "#39be9d",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.f7fdb67ca12524a63549c13bd4cbb334.svg";
export { ForwardRef as ReactComponent };